var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SettlementStepper',{attrs:{"vehicle-image":_vm.vehicleImage,"settlement":_vm.settlement,"stepper-value":true,"vehicle-title":_vm.vehicleTitle,"vehicle-sub-title":_vm.vehicleSubTitle,"settlement-steps":_vm.settlementSteps,"show-stepper-history":false,"is-mobile":_vm.$q.screen.xs}})
}
var staticRenderFns = []

export { render, staticRenderFns }